// document.addEventListener('DOMContentLoaded', () => {
//   const searchInput = document.getElementById('order-search');
//   searchInput.addEventListener('input', (e) => {
//     const query = e.target.value.toLowerCase().replace('#', '');
//     const orderCards = document.querySelectorAll('.order-card');
//     orderCards.forEach(card => {
//       const orderNumber = card.getAttribute('data-order-number').toLowerCase().replace('#', '');
//       card.style.display = orderNumber.includes(query) || query === '' ? 'flex' : 'none';
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('order-search');
  const orderListingBox = document.querySelector('.order-listing-box');
  
  // Create "No results" message
  const noResults = document.createElement('div');
  noResults.className = 'no-results';
  noResults.textContent = 'No orders match your search on this page.';
  noResults.style.display = 'none';
  orderListingBox.appendChild(noResults);

  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.toLowerCase().replace('#', '');
    const orderCards = document.querySelectorAll('.order-card');
    let visibleCount = 0;

    orderCards.forEach(card => {
      const orderNumber = card.getAttribute('data-order-number').toLowerCase().replace('#', '');
      const isVisible = orderNumber.includes(query) || query === '';
      card.style.display = isVisible ? 'flex' : 'none';
      if (isVisible) visibleCount++;
    });

    noResults.style.display = visibleCount === 0 && query !== '' ? 'block' : 'none';
  });
});